import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { useEffect, useState, useRef } from "react";
import SEO from "./seo.component";
import pageSEO from "../constants/pageSEO";

export default function Contact() {
  const [popup, setPopup] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    "Email Address": "",
    Message: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Form validation function
  const validateForm = () => {
    const errors = {};

    // Check if Name is empty
    if (!formData.Name.trim()) {
      errors.Name = "Name is required";
    }

    // Check if Email is empty and valid format
    if (!formData["Email Address"].trim()) {
      errors["Email Address"] = "Email is required";
    } else if (!validateEmail(formData["Email Address"])) {
      errors["Email Address"] = "Please enter a valid email address";
    }

    // Check if Message is empty
    if (!formData.Message.trim()) {
      errors.Message = "Message is required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  async function submitForm(event) {
    console.log("submitForm");
    event.preventDefault();

    // Validate form before submission
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    console.log("process.env.REACT_APP_AGENT_EMAIL");
    console.log(process.env.REACT_APP_AGENT_EMAIL);

    const emailFormData = new FormData();
    emailFormData.append('data', JSON.stringify({
      recipientEmails: [constants.AGENT_EMAIL],
      senderEmail: process.env.REACT_APP_AGENT_EMAIL,
      subject: "New Contact Form Message",
      content: formData.Message,
      senderName: formData.Name,
      replyTo: formData["Email Address"],
    }));

    let EmailApiUrl = process.env.REACT_APP_NODE_ENV === "production" ? "https://3.138.143.209/global/send-email" : "http://3.138.143.209/global/send-email";

    try {
      const response = await fetch(EmailApiUrl, {
        method: "POST",
        body: emailFormData,
      });

      if (!response.ok) {
        throw new Error("Failed to send email");
      }

      const res = await response.json();
      console.log("res", res);

      if (res?.message === "success") {
        console.log("Success", res);
        setPopup({
          subject: "Thanks for your message!",
          message: "We will get back to you as soon as possible",
        });
        // Clear form after successful submission
        setFormData({
          Name: "",
          "Email Address": "",
          Message: "",
        });
        setFormErrors({});
      } else {
        setPopup({
          subject: "We encountered an error in sending this message",
          message: "Please try again later",
        });
      }
    } catch (err) {
      console.log(err);
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  const seoConfig = pageSEO.contact();
  return (
    <>
      <SEO {...seoConfig} />
      <div className="w-full bg-light-grey flex flex-wrap gap-x-16 gap-y-10 justify-center py-16 px-7 min-h-[70vh] pt-[150px]">
        <div>
          <h4 className="font-mont font-semibold text-black text-lg min-w-[20vw]">
            Questions? I'm Here To Help
          </h4>
          <form onSubmit={submitForm} className="mt-6 flex flex-col">
            <div className="form-item">
              <label className="form-label">Name*</label>
              <input
                className={`form-input ${formErrors.Name ? 'border-red-500' : ''}`}
                name="Name"
                placeholder="Full Name"
                value={formData.Name}
                onChange={handleInputChange}
              />
              {formErrors.Name && (
                <p className="text-red-500 text-sm mt-1">{formErrors.Name}</p>
              )}
            </div>
            <div className="form-item">
              <label className="form-label">Email*</label>
              <input
                className={`form-input ${formErrors["Email Address"] ? 'border-red-500' : ''}`}
                name="Email Address"
                placeholder="Email Address"
                value={formData["Email Address"]}
                onChange={handleInputChange}
              />
              {formErrors["Email Address"] && (
                <p className="text-red-500 text-sm mt-1">{formErrors["Email Address"]}</p>
              )}
            </div>
            <div className="form-item">
              <label className="form-label">Message*</label>
              <textarea
                className={`form-input resize-none h-32 ${formErrors.Message ? 'border-red-500' : ''}`}
                name="Message"
                placeholder="Your Message"
                value={formData.Message}
                onChange={handleInputChange}
              />
              {formErrors.Message && (
                <p className="text-red-500 text-sm mt-1">{formErrors.Message}</p>
              )}
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className={`bg-black text-white px-10 py-3 mt-3 rounded hover:bg-logo-main self-start ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {isSubmitting ? 'Sending...' : 'Send'}
            </button>
          </form>
        </div>
        <div>
          <iframe
            className="contact-map"
            src={constants.MAP}
            height="365"
            width={`${windowSize > 900 ? "500" : "300"}`}
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>

          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black text-2xl">{constants.AGENT_NAME}</h2>
            <p className="italic">
              {constants.AGENT_TITLE}, {constants.BROKERAGE_NAME}
            </p>
            <p>
              <FontAwesomeIcon icon={faPhone} className="text-blue-800 fa-lg" />{" "}
              {constants.AGENT_NUMBER}{" "}
            </p>
            <p>
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-blue-800 fa-lg"
              />{" "}
              {constants.AGENT_EMAIL}{" "}
            </p>
          </div>
        </div>
      </div>
      {popup && (
        <>
          <div className="backdrop" />
          <div className="popup">
            <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
            <p className="font-semibold text-med-grey tracking-wide mb-3">
              {popup.message}
            </p>
            <button onClick={() => setPopup(false)} className="btn-rounded">
              Close
            </button>
          </div>
        </>
      )}
    </>
  );
}
